// src/components/LayerInfoModal.jsx

import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import '../styles/LayerInfoModal.css';

const LayerInfoModal = ({ isOpen, onRequestClose, layer }) => {
  if (!layer) return null; // Safety check

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={`${layer.name} Information`}
      className="layer-info-modal"
      overlayClassName="layer-info-modal-overlay"
      aria={{
        labelledby: "layer-info-title",
        describedby: "layer-info-content",
      }}
    >
      {/* Header */}
      <div className="modal-header">
        <h2 id="layer-info-title" className="modal-title">
          About: {layer.name}
        </h2>
        <button
          onClick={onRequestClose}
          className="close-button"
          aria-label="Close Modal"
        >
          &times;
        </button>
      </div>

      {/* Body */}
      <div id="layer-info-content" className="modal-body">
        <div className="info-table">
          {/* Function */}
          <div className="info-row">
            <div className="info-label">Function</div>
            <div className="info-value">{layer.function}</div>
          </div>

          {/* Coverage */}
          <div className="info-row">
            <div className="info-label">Coverage</div>
            <div className="info-value">{layer.coverage}</div>
          </div>

          {/* Source */}
          <div className="info-row">
            <div className="info-label">Source</div>
            <div
              className="info-value"
              dangerouslySetInnerHTML={{ __html: layer.source1 }}
            ></div>
          </div>

          {/* Methodology (conditionally render if present) */}
          {layer.methodology && (
            <div className="info-row">
              <div className="info-label">Methodology</div>
              <div
                className="info-value"
                dangerouslySetInnerHTML={{ __html: layer.methodology }}
              ></div>
            </div>
          )}

          {/* Time Range */}
          <div className="info-row">
            <div className="info-label">Time Range</div>
            <div className="info-value">{layer.timeRange}</div>
          </div>

          {/* Update Frequency */}
          <div className="info-row">
            <div className="info-label">Update Frequency</div>
            <div className="info-value">{layer.updateFrequency}</div>
          </div>

          {/* Resolution */}
          <div className="info-row">
            <div className="info-label">Resolution</div>
            <div className="info-value">{layer.resolution}</div>
          </div>

          {/* Credits */}
          <div className="info-row">
            <div className="info-label">Credits</div>
            <div
              className="info-value"
              dangerouslySetInnerHTML={{ __html: layer.credits }}
            ></div>
          </div>

          {/* Cautions (conditionally render if present) */}
          {layer.cautions && (
            <div className="info-row">
              <div className="info-label">Cautions</div>
              <div
                className="info-value"
                dangerouslySetInnerHTML={{ __html: layer.cautions }}
              ></div>
            </div>
          )}

          {/* Licence (conditionally render if present) */}
          {layer.Licence && (
            <div className="info-row">
              <div className="info-label">Licence</div>
              <div
                className="info-value"
                dangerouslySetInnerHTML={{ __html: layer.Licence }}
              ></div>
            </div>
          )}

          {/* Description */}
          <div className="info-row">
            <div className="info-label">Description</div>
            <div
              className="info-value"
              dangerouslySetInnerHTML={{ __html: layer.description }}
            ></div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="modal-footer">
        <button onClick={onRequestClose} className="close-modal-button">
          Close
        </button>
      </div>
    </Modal>
  );
};

LayerInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  layer: PropTypes.object,
};

export default LayerInfoModal;
